<template>
  <v-snackbar
    v-model="show"
    :bottom="options.bottom"
    :multi-line="options.multiLine"
    :timeout="options.timeout"
  >
    {{ message }}
    <v-btn
      v-if="options.dismissable"
      flat
      @click="hide"
      :color="options.dismissableColor"
    >{{ options.dismissableText }}</v-btn>
  </v-snackbar>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions, mapState } = createNamespacedHelpers('snackbar');

export default {
  data() {
    return {
      dismissable: true,
    };
  },
  computed: {
    ...mapState({
      message: state => state.message,
      options: state => state.options,
    }),
    show: {
      get() {
        return this.$store.state.snackbar.show;
      },
      set(value) {
        this.hide();
      },
    },
  },
  methods: {
    ...mapActions(['hide']),
  },
};
</script>
